import { render, staticRenderFns } from "./NotificationBubble.vue?vue&type=template&id=306ec17f&scoped=true"
import script from "./NotificationBubble.vue?vue&type=script&lang=js"
export * from "./NotificationBubble.vue?vue&type=script&lang=js"
import style0 from "./NotificationBubble.vue?vue&type=style&index=0&id=306ec17f&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "306ec17f",
  null
  
)

export default component.exports